import {ProjectFiltersDto} from "../../generated/api";
import {ProjectList} from "./ProjectList";
import {Flex} from "antd";
import {ProjectsChartYears} from "./ProjectsChartYears";
import {ProjectsPI} from "./ProjectsPI";

interface ProjectLayoutProps {
    filters: ProjectFiltersDto
    refreshKey: number
}

export function ProjectsDefaultLayout(props: Readonly<ProjectLayoutProps>) {
    return <div style={{display: "flex", flex: 1}} className={"analytics-page"}>
        <Flex vertical={true}>
            <Flex flex={1}>
                <ProjectsChartYears filters={props.filters} refreshKey={props.refreshKey}/>
                <ProjectsPI filters={props.filters} refreshKey={props.refreshKey}/>
            </Flex>
            <ProjectList filters={props.filters} refreshKey={props.refreshKey}/>
        </Flex>
    </div>
}